// 요금 및 결제
export const faqData1 = [
	{
		id: 1,
		summary: '결제 수단 삭제 방법이 궁금해요!',
		details:
			'[결제 및 인증]에서 카드 우측에 삭제버튼 선택하시면 결제수단이 삭제 됩니다. 단, 대표카드 1장만 등록되어 있는 경우 삭제가 불가능합니다.',
	},
	{
		id: 2,
		summary: '카드 등록 방법이 궁금해요!',
		details:
			'[결제 및 인증]에서 [+결제카드 등록하기]를 눌러 카드를 등록하시면 됩니다.',
	},
	{
		id: 3,
		summary: '할인 쿠폰 적용이 안됐어요.',
		details:
			'할인 조건에 부합하지 않을 경우 사용이 제한됩니다. 할인 쿠폰별 사용 조건 확인 후 이용바랍니다.',
	},
	{
		id: 4,
		summary: '결제 내역을 확인하고 싶어요!',
		details: '[라이딩 기록]에서 타고가 결제 내역 확인 가능합니다.',
	},
	{
		id: 5,
		summary: '환불 방법이 궁금해요!',
		details:
			'환불완료 까지는 통상 2~3일 정도 소요되며 자세한 사항은고객센터를 통해 연락주시면 도움드리도록 하겠습니다. \n신고하기: 사유에 맞는 항목을 선택하여 기기 및 고객정보를 상세히 작성해주세요.\n전화상담: 1811-6081',
	},
	{
		id: 6,
		summary: '이중 결제가 되었어요.',
		details:
			'[신고하기] 기타 항목]에 계정 정보(휴대폰 번호, 이름)와 이중결제된 수단 및 기기 정보를 상세히 작성해주세요.\n결제오류로 인해 과금된 금액은 환불 가능합니다.',
	},
	{
		id: 7,
		summary: '서비스 이용 요금이 궁금해요!',
		details:
			'(정상요금) 잠금해제 비용: 900원/5분, 추가 100원/분 (서비스 지역 별로 다름)\n(주의) 서비스 지역 이탈하여 반납 시 회수비용 5,000원 별도 부과\n서비스 오픈 이벤트(해당 지역) - 잠금해제 비용 무료 이벤트 요금\n(이벤트 요금) 잠금해제 비용: 0원, 1분당 100원\n(주의) 서비스 지역 이탈하여 반납 시 회수비용 5,000원 별도 부과',
	},
	{
		id: 8,
		summary: '서비스 이용요금결제방법(수단)이 궁금해요!',
		details:
			'[결제 및 인증]에서 최초 1회만 카드 정보를 등록하면, 운행 종료 후 등록된 카드로 자동 결제됩니다.\n여러 카드를 등록할 수 있으며 그 중 자동결제될 대표 카드를 선택할 수 있습니다.',
	},
	{
		id: 9,
		summary: '결제카드 등록 오류가 나요.',
		details:
			'[신고하기] 기타 항목에 계정 정보(휴대폰 번호, 이름)와 오류가 난 결제 수단 정보를 상세히 작성해주세요.\n결제오류로 인해 과금된 금액은 환불 가능합니다.',
	},
	{
		id: 10,
		summary: '결제카드 변경 방법이 궁금해요!',
		details:
			'[결제 및 인증]에서 여러 카드를 등록 및 삭제할 수 있으며, 그 중 자동 결제될 대표 카드를 선택 및 변경할 수 있습니다.',
	},
]

// 주차 관련
export const faqData2 = [
	{
		id: 11,
		summary: '주차 가능 지역이 궁금해요!',
		details:
			'주차 가능지역은 앱 지도상 밝게 표시된 영역입니다. 안전을 위해 되도록 서비스지역을 벗어나지 말아주세요. 앱 지도상 진한 자주색 영역에서는 주차 시 주차벌금(500원)이 부과 됩니다.\n통행에 방해가 되지 않도록 안전한 주차 부탁 드립니다.',
	},
	{
		id: 12,
		summary: '추천 주차 지역이 궁금해요!',
		details:
			'추천 주차 지역 내(앱 지도상 파란색 영역)에 올바른 주차 방법으로 주차 후 사진 첨부 하실 경우 배너핏이 적용됩니다.',
	},
	{
		id: 14,
		summary: '올바른 주차 방법',
		details:
			'[주차 관련] 올바른 주차 방법	\n라이더와 보행자 모두의 안전을 위해 아래의 내용을 참고하여 주차하여 주세요.\n\n[주차허용지역]\n1. 길 가장자리, 차량이나 보행자 통행에 불편을 주지 않는 길 가장자리에 주차해주세요.\n2. 추천주차지역, 목적지 근처에 위치한 추천주차지역에 안전하게 주차해주세요.\n\n[주차금지구역]\n1. 보행자 통행을 방해할 수 있는 보도 중앙\n2. 횡단보도, 산책로 등 보행자 진출입을 방해할 수 있는 구역\n3. 점자블록, 장애인 등 교통약자를 위한 엘리베이터 입구 및 진출입로 주변\n4. 버스정류장, 택시승강장 탑승자의 승하차, 지하철역 진출입을 방해하는 장소\n5. 건물, 상가, 빌딩 등의 차량 및 보행자 진출입을 방해할 수 있는 위치\n6. 차도와 보도가 구분되는 구역에서의 차도\n7. 차량 진출입을 위해 차도와 인도 사이 턱을 낮춘 진출입로\n8. 자전거 도로와 자전거 도로 진출입로\n9. 소방기본법에 따른 소방시설 5미터 이내 구역\n10. 육교 위, 지하보차도 안 보행 구조물 기능을 저해하는 공간\n11. 계단, 난간 등 낙하, 추락 등에 따른 사고 발생 가능 지역\n12. 터널 안 및 다리 위, 공사장 주변\n13. 도로관리청이 지정한 통행제한 구간',
	},
	{
		id: 15,
		summary: '주차한 사진을 왜 올리는지 궁금해요!',
		details:
			'다음 사용자가 편리하게 찾을 수 있고 안전하게 주차 되었는지 확인하기 위함입니다.',
	},
	{
		id: 20,
		summary: '반납금지구역, 주차금지구역의 페널티 비용이 궁금해요!',
		details:
			'서비스지역 밖(앱 지도상 어두운 영역)에서도 주차는 가능하지만, 주차 시 회수비용(5,000원)이 추가로 부과됩니다.\n서비스지역 내(앱 지도상 진한 자주색 영역)은 잦은 민원 신고 지역으로 주차를 금지 하고 있습니다. 주차 시 주차벌금(500원)이 추가로 부과됩니다.',
	},
	{
		id: 21,
		summary: '주차금지구역이 궁금해요!',
		details:
			'서비스지역 내에도 스쿨존, 위험지역 등과 같은 주차금지구역이 있습니다. 주차 금지지역(앱 지도상 진한 자주색 영역)에서는 주차 시 주차벌금(500원)이 부과 됩니다.\n또한 개인사유지, 자동차 및 장애인 전용 주차장, 상가 앞, 공공기관 앞 등에서는 주차를 자제해 주세요.(패널티가 발생할 수 있습니다.)',
	},
]

// 계정관련
export const faqData3 = [
	{
		id: 13,
		summary: '탈퇴 방법이 궁금해요!',
		details:
			'[탈퇴하기] 기능은 추후 업데이트 될 예정입니다.\n현재 탈퇴하고자 하시는 분들은 [신고하기] 의 기타 항목을 통해 탈퇴 의사를 밝혀주시면 탈퇴 진행하겠습니다.',
	},
	{
		id: 16,
		summary: '본인인증을 왜 두 번 하나요? (가입시, 카드등록시)',
		details:
			'최초 가입 시 진행되는 본인인증은 만 18세 이상임을 확인하는 나이 확인 절차입니다. 카드 등록 시 진행되는 본인인증은 본인 명의의 카드임을 확인하는 과정으로 결제대행사에서 진행하는 절차입니다.',
	},
	{
		id: 17,
		summary: '운전면허증 등록 방법이 궁금해요!',
		details:
			'현재 타고가 서비스는 운전면허증 등록이 필요하지 않지만 변경 시 공지와 푸시알람을 통해 안내 드릴 예정입니다.',
	},
	{
		id: 18,
		summary: '인증번호를 받지 못했어요.',
		details:
			'다음의 경우, 인증번호를 받지 못하실 수 있습니다.\n1.휴대폰 번호를 오기입 한 경우\n2.휴대폰 스팸 번호로 등록된 경우\n3.통신사 스팸 차단 서비스에 가입된 경우\n사용하시는 통신사의 스팸 차단 서비스를 해제 후 다시 시도해주세요.\n\n위 방법을 시도해도 문제가 계속된다면 고객센터(1811-6081)로 문의해주세요.',
	},
	{
		id: 19,
		summary: '개인정보를 수정하고 싶어요.',
		details:
			'사진 변경: [메뉴]>상단 이미지 클릭\n이름,전화번호 변경: [메뉴]>[설정]>수정버튼 클릭',
	},
	{
		id: 37,
		summary: 'SNS 로그인(라인, 카카오) 방법이 궁금해요!',
		details:
			'[카카오로 시작], [라인으로 시작] 버튼 중 선택하여 약관동의 후 로그인 가능합니다.\n동일 인물이어도 카카오와 라인은 연동되지 않고 따로 운영되는 점 참고 바랍니다.',
	},
]

// 보험
export const faqData4 = [
	{
		id: 22,
		summary: '사고 발생 시 어떻게 대처하는지 궁금해요!',
		details:
			'사고 발생 직후 바로 고객센터(1811-6081)로 연락주시면 사고처리 방침에 따라 도움 드리겠습니다.',
	},
]

// 고장
export const faqData5 = [
	{
		id: 25,
		summary: '기기에서 소리가 나요.',
		details:
			'정상 대여에도 불구하고 기기에서 소리가 난다면 안전한 곳에 기기를 주차하고 앱 내 고장 신고 접수 또는 고객센터로 문의 바랍니다. 기기 고장으로 인한 과금은 환불해 드리겠습니다.',
	},
	{
		id: 26,
		summary: '기기고장 신고는 어떻게 하나요?',
		details:
			'1. 랜딩페이지: 우측 하단 말풍선&느낌표 아이콘 클릭\n2. 해당 기기 상세: 기기 상세정보에서 우측 상단 말풍선&느낌표 아이콘 클릭\n3. 고객센터 내: [메뉴]>[고객센터]>우측 상단 [신고하기] 링크 클릭',
	},
	{
		id: 27,
		summary: '기기대여를 했는데 기기가 안가요.',
		details:
			'고장 신고 접수 또는 고객센터로 문의 주시면 신속하게 도움을 드리겠습니다. 기기 고장으로 인한 과금은 환불해 드리겠습니다.',
	},
]

// 서비스 이용
export const faqData6 = [
	{
		id: 28,
		summary: '폭설, 우천시에도 이용 가능한가요?',
		details:
			'지역별 기상 상황이 다르기 때문에 지역에 따라 이용이 불가한 경우 앱 내 공지사항과 푸시알람을 통해서 확인하시길 바랍니다.',
	},
	{
		id: 29,
		summary: '안전을 위해 준수할 사항에는 어떤 게 있나요?',
		details:
			'라이더의 안전한 타고가 이용을 위해 함께 약속을 지켜주세요.\n1. 기기확인(바퀴, 핸들, 브레이크, 악셀)\n2. 헬멧 착용\n3. 음주 금지\n4. 1인 탑승(2인 이상 금지)\n5. 매너 주차',
	},
	{
		id: 30,
		summary: ' 서비스 운영 시간이 궁금해요.',
		details:
			'서비스 운영은 365일 24시간 운영되고 있습니다. 다만 일기예보, 기상상황 이에 따른 노면 상태에 따라 탄력적으로 운영합니다.',
	},
	{
		id: 31,
		summary: '서비스 지역은 어디인가요?',
		details:
			'정상 서비스 지역은 타고가 앱에서 보실 때 지도 배경 지역의 안쪽에 있는 밝은 부분입니다.\n서비스 지역 안 붉은색 어두운 부분은(진한 자주색) 주차 벌금 구역이며, 밝은 부분을 제외한 어두운 부분은 반납 금지 지역이며, 반납 금지 지역에서 반납하시면 회수비용(5,000원)이 부과됩니다.',
	},
	{
		id: 32,
		summary: '타고가 이용방법이 궁금해요!',
		details:
			'라이더의 편리한 타고가 이용을 위해 다음과 같은 순서를 따라주세요.\n1. <타고가> 앱 다운로드\n2. <타고가> 앱 설치 후 본인 인증 및 결제수단 등록\n3. 앱에서 [대여하기] 누른 뒤 킥보드 QR스캔하여 이용',
	},
	{
		id: 33,
		summary: '타고가 작동방법이 궁금해요!',
		details:
			'라이더의 안전한 이용을 위해 타고가 작동 방법을 익혀주세요.\n(출발) 발로 땅을 밀며 가속 레버 동작\n(정지) 브레이크를 서서히 잡으며 멈춤',
	},
	{
		id: 34,
		summary: '고객센터 운영 시간이 궁금해요!',
		details:
			'고객센터(1811-6081) 운영시간은 평일 09:00~17:00 까지만 운영하고 있으며, 운영 시간 외에는 타고가 앱의 [신고하기] 기능을 이용하여 남겨주시면 운영 시간 중 확인하여 처리하도록 하겠습니다.',
	},
	{
		id: 35,
		summary: '타고가를 이용할 수 있는 회원 자격은 어떻게 되나요?',
		details:
			'타고가에 회원가입을 한 만 18세 이상의 회원은 누구나 이용이 가능합니다.',
	},
	{
		id: 36,
		summary: '이용약관은 어디서 확인하나요?',
		details: '[메뉴] > [설정] 왼쪽 하단 에서 확인가능합니다.',
	},
]
